import React, { Component } from 'react';

import moment from 'moment';
import { bool, instanceOf, oneOfType, string } from 'prop-types';

import { CustomPropTypes } from '@philips-emr/tws-core/lib/component';
import { classNames, enumValues } from '@philips-emr/tws-utils';

import './card-date.scss';

const { oneOf } = CustomPropTypes;

class CardDateType {
  static DEFAULT = 'default';
  static FEATURED = 'featured';
}

class CardDate extends Component {
  static propTypes = {
    className: string,

    /** Define the date that should be rendered. */
    date: oneOfType([
      string,
      instanceOf(moment),
    ]),

    /** Define how the component should render itself. */
    type: oneOf(enumValues(CardDateType)),

    /** Define whether the should or not display the pipe divider. */
    divider: bool,
  };

  static defaultProps = {
    type: '',
    divider: false,
  };

  render() {
    const { date, divider, type, className } = this.props;

    const isFeaturedCard = type === CardDateType.FEATURED;

    const rootClasses = {
      'c-card-date': true,
      'c-card-date--featured': isFeaturedCard,
      [className]: className,
    };

    if (!date) {
      return <div className={classNames(rootClasses)} />;
    }

    const momentDate = moment(date).utc();

    const dateParts = [
      momentDate.format('DD'),
      momentDate.format('MMM').toUpperCase(),
      isFeaturedCard ? momentDate.format('HH:mm') : momentDate.format('YYYY'),
    ];

    return (
      <div className={classNames(rootClasses)}>
        <span className="c-card-date__item c-card-date__item--first">{dateParts[0]}</span>

        <div className="c-card-date__group">
          <span className="c-card-date__item c-card-date__item--second">{dateParts[1]}</span>
          {divider && <i className="c-card-date__item c-card-date__item--divider"></i>}
          <span className="c-card-date__item c-card-date__item--third">{dateParts[2]}</span>
        </div>
      </div>
    );
  }
}

export default CardDate;
